import { motion } from "framer-motion";
import { useLanguage } from "@/i18n/LanguageContext";
import heroImage from "@/assets/hero-main.webp";
import logoHero from "@/assets/logo-hero.webp";
import logoText from "@/assets/logo-text.webp";

const HeroSection = () => {
  const { t } = useLanguage();

  return (
    <section className="relative min-h-[100vh] flex flex-col items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <video
          src="/videos/hero-main.mov"
          autoPlay
          muted
          loop
          playsInline
          className="w-full h-full object-cover scale-105"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-foreground/50 via-foreground/20 to-foreground/60" />
        <div className="absolute bottom-0 left-0 right-0 h-40 bg-gradient-to-b from-transparent to-background" />
      </div>

      <div className="relative z-10 text-center px-8 flex flex-col items-center">
        <h1 className="sr-only">
          {t(
            "Arzani Group — Curated luxury concierge across distinguished destinations",
            "Arzani Group — Samengestelde luxe concierge op onderscheidende bestemmingen"
          )}
        </h1>
        <motion.img
          src="/images/logo-hero.webp"
          alt="Arzani Group"
          className="h-20 md:h-28 lg:h-40 mb-8"
          fetchPriority="high"
          initial={{ opacity: 0, scale: 0.9 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ delay: 0.6, duration: 1.8, ease: [0.22, 1, 0.36, 1] }}
        />

        <motion.p
          className="font-body text-primary-foreground/60 text-xs md:text-sm max-w-sm leading-relaxed tracking-wide"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 1.8, duration: 1.8, ease: [0.22, 1, 0.36, 1] }}
        >
          {t(
            "Curated experiences across the world's most distinguished destinations.",
            "Samengestelde ervaringen op 's werelds meest onderscheidende bestemmingen."
          )}
        </motion.p>

        <motion.a
          href="#destinations"
          className="mt-6 px-8 py-3 border border-primary-foreground/40 text-primary-foreground/80 text-xs md:text-sm tracking-[0.2em] uppercase font-label hover:bg-primary-foreground/10 transition-colors duration-300"
          initial={{ opacity: 0, y: 10 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 2.2, duration: 1.4, ease: [0.22, 1, 0.36, 1] }}
        >
          {t("Explore Our Destinations", "Ontdek Onze Bestemmingen")}
        </motion.a>
      </div>

      <motion.div
        className="absolute bottom-12 left-1/2 -translate-x-1/2 flex flex-col items-center gap-4"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 2.5, duration: 1.5, ease: [0.22, 1, 0.36, 1] }}
      >
        <span className="font-label text-primary-foreground/30 text-[8px]">Scroll</span>
        <div className="w-px h-8 bg-primary-foreground/20" />
      </motion.div>
    </section>
  );
};

export default HeroSection;
